import React from 'react';

import { Checkbox, cn } from '@src/components/ui';


/**
 * Base checkbox field — checkbox with inline label, helper/error line below.
 * Receives RHF field props (value/onChange/onBlur/name/ref) plus `error`/`helperText`
 * from the generic form wrapper. RHF stores the boolean, not the event.
 */
const CheckboxField = React.forwardRef((props, ref) => {
  const {
    label,
    children,
    value = false,
    onChange,
    error = false,
    helperText = ' ',
    className,
    ...restProps
  } = props;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <Checkbox
        ref={ref}
        invalid={error}
        checked={Boolean(value)}
        onChange={(event) => onChange?.(event.target.checked)}
        {...restProps}
      >
        {children ?? label}
      </Checkbox>

      <p className={cn('min-h-4 text-xs', error ? 'text-danger' : 'text-ink-subtle')}>
        {helperText}
      </p>
    </div>
  );
});

CheckboxField.displayName = 'CheckboxField';
export default CheckboxField;
